import { LOCALES, useI18n, type Locale } from '../../i18n'
import styles from './LanguageSwitcher.module.css'

type Props = {
  className?: string
  /** Compact control for headers; default is the landing hero placement. */
  compact?: boolean
}

const LOCALE_LABEL_KEY = {
  en: 'lang.en',
  ja: 'lang.ja',
  'zh-Hant': 'lang.zhHant',
} as const

export function LanguageSwitcher({ className, compact = false }: Props) {
  const { locale, setLocale, t } = useI18n()

  return (
    <div className={`${styles.root} ${compact ? styles.compact : ''} ${className ?? ''}`}>
      <label className={styles.label} htmlFor={compact ? 'lang-switch-compact' : 'lang-switch'}>
        {t('lang.label')}
      </label>
      <select
        id={compact ? 'lang-switch-compact' : 'lang-switch'}
        className={styles.select}
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {t(LOCALE_LABEL_KEY[code])}
          </option>
        ))}
      </select>
    </div>
  )
}
